'use strict';

angular.module('cfn').factory('bookingMaskService', bookingMaskService);

bookingMaskService.$inject = [
  '$http',
  '$q',
  '$rootScope',
  '$timeout',
  'translateFilter',
  '$injector',
  'userSettingsService'
];
function bookingMaskService(
  $http,
  $q,
  $rootScope,
  $timeout,
  translateFilter,
  $injector,
  userSettingsService
) {
  // Init variables
  let activeCrop = null;
  let resetTimer = null;

  // Helper functions
  let fieldsWithDifferentCrops = fields => {
    let fieldsWithDifferentCrops = false;
    if (fields && fields.length) {
      // if the first field is already without a crop
      // we don't have to check the other fields
      if (typeof fields[0].cropOnField !== 'undefined') {
        if (
          typeof fields[0].cropOnField.sysCultureDTO !== 'undefined' &&
          fields[0].cropOnField.sysCultureDTO
        ) {
          let firstCropId = fields[0].cropOnField.sysCultureDTO.id;
          fields.forEach(field => {
            let currentCropId = 'undefined';
            if (
              typeof field.cropOnField !== 'undefined' &&
              typeof field.cropOnField.sysCultureDTO !== 'undefined' &&
              field.cropOnField.sysCultureDTO
            ) {
              currentCropId = field.cropOnField.sysCultureDTO.id;
            }
            if (currentCropId !== firstCropId) {
              fieldsWithDifferentCrops = true;
              return fieldsWithDifferentCrops;
            }
          });
        }
      }
    }
    return fieldsWithDifferentCrops;
  };

  let fieldsWithoutCrops = fields => {
    let fieldsWithoutCrops = false;
    if (fields && fields.length) {
      fields.forEach(field => {
        if (typeof field.cropOnField !== 'undefined') {
          if (typeof field.cropOnField.sysCultureDTO === 'undefined') {
            fieldsWithoutCrops = true;
            return fieldsWithoutCrops;
          } else if (!field.cropOnField.sysCultureDTO) {
            fieldsWithoutCrops = true;
            return fieldsWithoutCrops;
          }
        } else {
          fieldsWithoutCrops = true;
        }
      });
    }
    return fieldsWithoutCrops;
  };

  let setActiveCrop = crop => {
    activeCrop = crop;
  };

  let getActiveCrop = () => {
    return activeCrop;
  };

  let shouldResetIndication = (crop, scope) => {
    let resettableIndications = false;
    let items = scope.items;
    // if there were no indications, we don't have to reset them
    items.forEach(item => {
      if(item.indication) {
        resettableIndications = true;
      }
    });

    // timeout to prevent a double reset
    if(!resetTimer && crop && crop.sysCultureDTO && resettableIndications) {
      let resetTimer = 2500;
      $timeout(() => {
        resetTimer = null;
      }, resetTimer);
      if (getActiveCrop()) {
        if (crop.sysCultureDTO.id !== getActiveCrop().sysCultureDTO.id) {
          return true;
        }
      }
    }
    return false;
  };

  // end helper functions

  let getIndications = (plantProtectantId, cropPrincipalId) => {
    let deferred = $q.defer();
    let params = {
      url: `/365FarmNet/mod/catalog-service/rest/v1.0/indications/${plantProtectantId}/${cropPrincipalId}`,
      method: 'GET'
    };

    $http(params).then(
      response => {
        if (!response.data || !response.data.length) {
          // if the backend returns an empty list we want to handle it
          // like an error case
          return deferred.reject(response.data);
        }
        return deferred.resolve(response.data);
      },
      error => {
        return deferred.reject(error);
      }
    );
    return deferred.promise;
  };

  let getMaxDose = (plantProtectantId, cropPrincipalId, eppoCode, indicationCode) => {
    // get max dose of indication for the current crop and supply
    const httpInterceptorName = 'CfnHttpInterceptor';
    let deferred = $q.defer();
    let params = {
      url: `/365FarmNet/mod/catalog-service/rest/v1.0/indications/maxdose/${plantProtectantId}/${cropPrincipalId}/${eppoCode}/${indicationCode}`,
      method: 'GET'
    };

    // this function prevents a error message in case there is no
    // indication and the backend return a 404 error
    if ($injector.has(httpInterceptorName)) {
      let CfnHttpInterceptor = $injector.get(httpInterceptorName);
      CfnHttpInterceptor.configureInterception(
        params.url.toString(),
        404,
        CfnHttpInterceptor.createConfiguration({ doNotThrowError: true })
      );
    }

    $http(params).then(
      response => {
        if (!response.data) {
          // if the backend returns an empty list we want to handle it
          // like an error case
          return deferred.reject(response.data);
        }

        return deferred.resolve(response.data);
      },
      error => {
        return deferred.reject(error);
      }
    );

    return deferred.promise;
  };

  let fieldUpdate = () => {
    // broadcast if something was changed in the bookingmask
    $rootScope.$broadcast('bookingmask-field-update');
  };

  let resetIndications = () => {
    // broadcast if selected indications have to be resetted
    $rootScope.$broadcast('bookingmask-reset-indication');
  };

  let checkIfIndicationsAllowed = (parentScope, model, checkResetIndications, selectedCulture) => {
    let isIndicationsAllowed = false;
    // check if indications are allowed for the current crop and fields
    if (typeof parentScope !== 'undefined' && parentScope.details.fieldList && parentScope.details.fieldList.length ) {
      if (selectedCulture) {
        if (['DEU', 'FRA', 'CHE'].indexOf(userSettingsService.getIsoCountryEnum()) !== -1) {
          setActiveCrop(selectedCulture);
          isIndicationsAllowed = true;
        }
      }
    }

    return isIndicationsAllowed;
  };

  // Public
  return {
    setActiveCrop: setActiveCrop,
    getActiveCrop: getActiveCrop,
    getIndications: getIndications,
    getMaxDose: getMaxDose,
    fieldUpdate: fieldUpdate,
    checkIfIndicationsAllowed: checkIfIndicationsAllowed,
    resetIndications: resetIndications,
    shouldResetIndication: shouldResetIndication,
    fieldsWithDifferentCrops: fieldsWithDifferentCrops,
    fieldsWithoutCrops: fieldsWithoutCrops
  };
}

export default bookingMaskService;
